import { spawn } from 'redux-saga/effects';

import auth0Sagas from './auth0Sagas';
import authSagas from './authSagas';

export function* dxAuthSagas() {
  yield spawn(authSagas);
  yield spawn(auth0Sagas);
}
